import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import styled from 'styled-components';
import PT from 'prop-types';
import { $ as $f7dceffc5ad7768b$export$4e328f61c538687f } from '../../3rdPartyModules/_react-aria/focus/dist/useFocusRing-dee26278.js';
import { $ as $3ef42575df84b30b$export$9d1611c77c2fe928 } from '../../3rdPartyModules/_react-aria/utils/dist/mergeProps-29aac069.js';
import { s as switchStyle, S as SliderButton, C as Checkmark } from './InnerSwitch.styles-2de73e49.js';
import { n as noop } from '../../LocalModules/storm-ui-utils/dist/esm/noop-ea7cc233-62dc80e0.js';
import { c as check } from '../../LocalModules/storm-ui-icons/dist/esm/localIcons-889a4ef1-4d9affee.js';

const switchPropTypes = {
  id: PT.string.isRequired,
  className: PT.string,
  /**
   * Denotes if the Switch should be toggled.
   */
  toggled: PT.bool,
  /**
   * Denotes if the Switch should be disabled.
   */
  disabled: PT.bool,
  /**
   * Returns callback of (value, event).
   */
  onChange: PT.func,
  /**
   * Denotes if the Switch should be small.
   */
  small: PT.bool,
  /**
   * Used to provide a customized aria-label to the Switch. For accessibility purposes only.
   */
  switchLabel: PT.string
};
const switchDefaultProps = {
  onChange: noop,
  toggled: false,
  disabled: false,
  small: false,
  switchLabel: undefined,
  className: ''
};
const SwitchComponent = ({
  disabled,
  toggled,
  onChange,
  small,
  switchLabel,
  className,
  id,
  ...rest
}) => {
  const {
    isFocusVisible,
    focusProps
  } = $f7dceffc5ad7768b$export$4e328f61c538687f();
  const handleOnChange = event => {
    onChange(!event.currentTarget.checked, event);
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: className
  }, /*#__PURE__*/React__default.createElement(SliderButton, _extends({
    id: id,
    "aria-label": switchLabel,
    role: "switch",
    onClick: handleOnChange,
    checked: toggled,
    toggled: toggled,
    "aria-checked": toggled,
    disabled: disabled,
    focusVisible: isFocusVisible,
    type: "button",
    small: small
  }, $3ef42575df84b30b$export$9d1611c77c2fe928(rest, focusProps)), /*#__PURE__*/React__default.createElement(Checkmark, {
    type: check,
    $toggled: toggled,
    $disabled: disabled,
    $small: small,
    "aria-hidden": true
  })));
};
SwitchComponent.propTypes = switchPropTypes;
SwitchComponent.defaultProps = switchDefaultProps;
const InnerSwitch = /*#__PURE__*/styled(SwitchComponent).withConfig({
  componentId: "sc-storm-ui-30045097__sc-cf586t-0"
})(["", ""], switchStyle);
InnerSwitch.displayName = 'InnerSwitch';
InnerSwitch.propTypes = switchPropTypes;
InnerSwitch.defaultProps = switchDefaultProps;
var InnerSwitch$1 = InnerSwitch;

export { InnerSwitch$1 as I };
//# sourceMappingURL=InnerSwitch-6d5badad.js.map
